import styled from 'styled-components';
import { PhotographyWrapper } from '../photography/PhotographyStyles';

export const CareersWrapper = styled(PhotographyWrapper)`
  a.photo-primary { display: inline-block; text-decoration: none; text-align: center; }
  .careers-hero-images { display: grid; grid-template-columns: 1fr 1fr; grid-template-rows: 244px 244px; gap: 16px; }
  .careers-hero-images img { display: block; width: 100%; height: 100%; object-fit: cover; border-radius: 16px; }
  .careers-hero-images .careers-camera { grid-row: span 2; }
  .careers-hero-images img:nth-child(2) { object-position: center 70%; }
  .careers-benefits-band { background: #f6f8fc; }
  .careers-benefits { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 40px; padding-top: 48px; padding-bottom: 48px; }
  .careers-benefits h2 { font: 600 22px/1.4 Poppins,sans-serif; color: #1b264f; letter-spacing: -.025em; text-transform: none; margin: 0 0 12px; }
  .careers-benefits p, .careers-steps p { font: 400 17px/1.7 'Nunito Sans',sans-serif; color: #52617e; margin: 0; }
  .careers-benefits .photo-step-number { font-size: 20px; margin-bottom: 16px; }
  .careers-craft-image { display: block; width: 100%; height: 420px; border-radius: 16px; object-fit: cover; object-position: center; }
  .careers-skills { padding-top: 24px; }
  .careers-intro { display: grid; grid-template-columns: 1fr 1fr; gap: 56px; align-items: center; }
  .careers-intro .photo-title, .careers-intro .photo-copy { margin-bottom: 0; }
  .careers-roles { display: grid; grid-template-columns: repeat(5,minmax(0,1fr)); gap: 24px; margin-top: 36px; }
  .careers-role { border-top: 1px solid #cbd5e9; padding-top: 24px; }
  .careers-role-icon { display: inline-grid; place-items: center; width: 44px; height: 44px; background: #e8eeff; color: #2c5bff; border-radius: 10px; margin-bottom: 18px; }
  .careers-role h3 { font-size: 18px; }
  .careers-role p { font: 400 16px/1.65 'Nunito Sans',sans-serif; color: #52617e; margin: 0; }
  .careers-process-band { background: #f6f8fc; }
  .careers-process { display: grid; grid-template-columns: 1fr 1.2fr; gap: 72px; align-items: start; scroll-margin-top: 24px; }
  .careers-steps { list-style: none; padding: 0; margin: 0; }
  .careers-steps li { display: grid; grid-template-columns: 44px 1fr; gap: 20px; border-bottom: 1px solid #dce3ef; padding: 24px 0; }
  .careers-steps li:first-child { padding-top: 0; }
  .careers-steps li:last-child { padding-bottom: 0; border-bottom: 0; }
  .careers-steps h3 { margin-bottom: 8px; }
  .careers-steps .photo-step-number { font-size: 24px; margin-bottom: 0; }
  .careers-area .photo-copy { margin-bottom: 20px; }
  .careers-map { max-width: 950px; margin: 24px auto 0; }
  .careers-map svg.rsm-svg { display: block; width: 100%; height: auto; }
  .careers-map-note { font: 400 15px/1.6 'Nunito Sans',sans-serif; color: #52617e; text-align: center; margin: 12px 0 0; }
  @media(max-width:991px) { .careers-intro { gap: 32px; } .careers-benefits { gap: 24px; } .careers-roles { grid-template-columns: repeat(3,minmax(0,1fr)); } .careers-process { gap: 32px; } }
  @media(max-width:767px) {
    .careers-hero-images { grid-template-rows: 164px 164px; gap: 12px; }
    .careers-hero-images img { border-radius: 12px; }
    .careers-benefits { grid-template-columns: 1fr; gap: 28px; padding-top: 36px; padding-bottom: 36px; }
    .careers-benefits > div { display: grid; grid-template-columns: 36px 1fr; column-gap: 16px; }
    .careers-benefits .photo-step-number { grid-row: span 2; }
    .careers-benefits h2 { font-size: 20px; }
    .careers-benefits p { grid-column: 2; font-size: 16px; }
    .careers-craft-image { height: 280px; }
    .careers-skills { padding-top: 0; }
    .careers-intro, .careers-process { grid-template-columns: 1fr; gap: 24px; }
    .careers-roles { grid-template-columns: repeat(2,minmax(0,1fr)); gap: 24px 16px; margin-top: 28px; }
    .careers-role h3 { font-size: 17px; }
    .careers-role p { font-size: 15px; }
    .careers-steps { margin-top: 8px; }
    .careers-steps li { grid-template-columns: 36px 1fr; gap: 16px; }
    .careers-steps h3 { font-size: 19px; }
    .careers-steps p { font-size: 16px; }
    .careers-map-note { font-size: 14px; }
  }
`;